import { buildUrl } from '../helpers';
export default {
    props: {
        useFavorite: {
            type: Boolean,
            required: false,
            default: false,
        },
        list: {
            type: [Array, Object],
            required: false,
            default: () => [],
        },
        favoriteName: {
            type: String,
            required: false,
        },
        index: {
            type: [Number, Boolean],
            required: false,
            default: false,
        },
    },

    methods: {
        buildUrl,
        toggleFavorite() {
            this.$emit('toggleFavorite');
        },
    },
    computed: {
        isFavorite() {
            if (this.list.length > 0) {
                const favorite = this.list.find(
                    (itemFav) =>
                        this.buildUrl(itemFav.favoriteName, [
                            { key: 'position', value: this.index },
                        ]) == this.favoriteName,
                );
                return favorite ? true : false;
            }
            return false;
        },
        isFavoriteClass() {
            return this.isFavorite ? 'icon-star-full-fillout' : 'show-hover-item icon-star';
        },
    },
};
